const isOnSale = ({ price, compareToPrice }) => compareToPrice && compareToPrice > price;

export default isOnSale;
